import { stableId } from './ids';

const DEFAULT_MARKER_COLOR = '#00D4AA';

export function ensureMarkerIds(markers = [], makeId = () => stableId('marker')) {
  return markers.map((marker) => marker.id ? marker : { ...marker, id: makeId() });
}

export function sectionBars(lineCount) {
  return Math.max(4, Math.ceil(lineCount / 4) * 4);
}

export function layoutSections(sections = [], makeId = () => stableId('marker')) {
  let nextBar = 0;
  let overflowCount = 0;
  const markers = [];
  const lyricsSections = [];

  sections.forEach((section) => {
    const bars = sectionBars(section.lines?.length || 0);
    const sectionId = section.id || stableId('section');
    if (nextBar + bars > 80) {
      overflowCount += 1;
      lyricsSections.push({ ...section, id: sectionId, marker_id: null });
      return;
    }
    const markerId = makeId();
    markers.push({
      id: markerId,
      name: section.label,
      startBar: nextBar,
      color: DEFAULT_MARKER_COLOR,
    });
    lyricsSections.push({ ...section, id: sectionId, marker_id: markerId });
    nextBar += bars;
  });

  const totalBars = Math.max(16, Math.ceil(nextBar / 8) * 8);
  return { markers, sections: lyricsSections, totalBars, overflowCount };
}

export function markerSections(markers = [], sections = []) {
  const markerIds = new Set(markers.map((marker) => marker.id));
  const byMarker = new Map(
    sections.filter((section) => section.marker_id).map((section) => [section.marker_id, section]),
  );
  const onTimeline = [...markers]
    .sort((a, b) => a.startBar - b.startBar)
    .map((marker) => byMarker.get(marker.id) || {
      id: null,
      marker_id: marker.id,
      label: marker.name,
      lines: [],
      virtual: true,
    });
  const detached = sections.filter((section) => !section.marker_id || !markerIds.has(section.marker_id));
  return { onTimeline, detached };
}

export function overflowNotice(count) {
  if (!count) return '';
  return `${count} section${count === 1 ? '' : 's'} didn't fit in 80 bars. `
    + `${count === 1 ? 'Its' : 'Their'} lyrics are below.`;
}
